if (!customElements.get('c-flag-series-carousel')) {
  customElements.define(
    'c-flag-series-carousel',
    class FlagSeriesCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.c-flag-series__grid');
        this.cards = Array.from(this.querySelectorAll('.c-flag-series__card'));
        this.slider = null;
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.init = this.init.bind(this);

        if (!this.track || !this.cards.length) return;

        this.mobileQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
        this.init();
      }

      disconnectedCallback() {
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
        this.destroy();
      }

      handleBreakpointChange() {
        this.init();
      }

      init() {
        if (this.mobileQuery.matches) {
          this.initSlider();
        } else {
          this.destroy();
        }
      }

      initSlider() {
        if (this.slider || !window.FoxTheme.Carousel) return;

        this.classList.add('swiper');
        this.track.classList.add('swiper-wrapper');
        this.cards.forEach((card) => card.classList.add('swiper-slide'));
        this.slider = new window.FoxTheme.Carousel(this, {
          slidesPerView: 1.08,
          spaceBetween: 12,
          grabCursor: true,
          loop: false,
          threshold: 2,
          observer: true,
          observeParents: true,
        });
        this.slider.init();
      }

      destroy() {
        if (this.slider && this.slider.slider) this.slider.slider.destroy(true, true);
        this.slider = null;
        this.classList.remove('swiper');
        this.track.classList.remove('swiper-wrapper');
        this.cards.forEach((card) => card.classList.remove('swiper-slide'));
      }
    }
  );
}